/* eslint-disable no-param-reassign */
import Vue from 'vue'
import { $_bridge } from '@/nms/plugins/bridge.js'
import { CCMDBObject } from '@entcor/ebridge'

// Типы для устройств и связанных объектов
interface TreeItem {
  $id: string
  id?: string
  cls: string
  name?: string
  children?: TreeItem[]
  links?: TreeItem[]
  parents?: any[]
  tree_view?: boolean
  [key: string]: any
}

interface DialogData {
  id: string
  [key: string]: any
}

interface DialogState {
  show: boolean
  data?: DialogData
}

interface DevicesState {
  sidebar: {
    active: string | null
  }
  dialog: Record<string, DialogState>
  rootElement: any | null
  showTree: boolean
  tree: TreeItem[]
  treeActive: TreeItem[]
  currentTreeActive: TreeItem | null
  treeOpened: TreeItem[]
  onceTreeOpened: TreeItem[] // содержит все объекты когда либо открытые в дереве (служит для апдейта отдельных веток дерева)
  activeCabinet: any | null
  selectedLocation: Record<string, any> // state for navigate from crumbs
  activeParent: Record<string, any>
  devices: any[]
  activeDevice: any[] | any | null
  selectedItem: any | null
  createRootShow: boolean
}

// Функция получения начального состояния
const getDefaultState = (): DevicesState => {
  return {
    sidebar: {
      active: null,
    },
    dialog: {},
    rootElement: null,
    showTree: true, //костыль для дерева при добавлении элемента в корневой уровень
    tree: [],
    treeActive: [],
    currentTreeActive: null, //костыль для дерева (чтобы при удалении элемента из корня дерево могло остаться без currentTreeActive)
    treeOpened: [],
    onceTreeOpened: [], // содержит все объекты когда либо открытые в дереве (служит для апдейта отдельных веток дерева)
    activeCabinet: null,
    selectedLocation: {},
    activeParent: {},
    devices: [],
    activeDevice: [],
    selectedItem: null,
    createRootShow: false,
  }
}

const state: DevicesState = getDefaultState()

export default {
  state,

  mutations: {
    RESET_DEV_STATE(state: DevicesState) {
      const defaultState = getDefaultState()
      Object.assign(state, defaultState)
    },

    LOAD_TREE(state: DevicesState, data: TreeItem[]) {
      Vue.set(state, 'showTree', false) //костыль для дерева при добавлении элемента в корневой уровень
      Vue.set(state, 'activeDevice', null)
      Vue.set(state, 'tree', data)
      Vue.nextTick(() => {
        Vue.set(state, 'showTree', true) //костыль для дерева при добавлении элемента в корневой уровень
      })   
    },

    SET_ROOT_ELEMENT(state: DevicesState, data: any) {
      Vue.set(state, 'rootElement', data)
    },

    SET_DIALOG(state: DevicesState, data: DialogData) {
      Vue.set(state.dialog, data.id, {
        show: true,
        data: data
      })
    },

    CLOSE_DIALOG(state: DevicesState, data?: { id: string }) {
      if(data?.id) {
        Vue.set(state.dialog, data.id, {
          show: false
        })
        delete state.dialog[data.id]
      } else {
        Vue.set(state, 'dialog', {})
      }
    },

    CURRENT_ROOT_SHOW(state: DevicesState, data: boolean) {
      state.createRootShow = data
    },

    ACTIVE_SIDEBAR(state: DevicesState, data: string | null) {
      Vue.set(state.sidebar, 'active', data || null)
    },

    ACTIVE_TREE(state: DevicesState, data: TreeItem[]) {
      console.log('ACTIVE_TREE data', data)
      Vue.set(state, 'activeCabinet', null)
      Vue.set(state, 'activeDevice', null)
      Vue.set(state, 'treeActive', data)
    },

    CURRENT_ACTIVE_TREE(state: DevicesState, data: string | null) {
      Vue.set(state, 'currentTreeActive', data || null)
    },

    UPDATE_TREE(state: DevicesState, data: TreeItem) {
      // console.log('STORE', 'UPDATE_TREE data', data)
      if(state.treeActive.length) {
        if(state.treeActive[0].$id === data.$id) {
          Vue.set(state.treeActive, [0], data)
        }
      }
      if(state.treeOpened.length) {
        if(state.treeOpened[state.treeOpened.length - 1].$id === data.$id) {
          Vue.set(state.treeOpened, [state.treeOpened.length - 1], data)
        }
      }
    },

    ACTIVE_CABINET(state: DevicesState, data: any) {
      Vue.set(state, 'activeCabinet', data)
    },

    SELECTED_LOCATION(state: DevicesState, data: Record<string, any>) {
      Vue.set(state, 'selectedLocation', data)
    },

    ACTIVE_PARENT(state: DevicesState, data: Record<string, any>) {
      Vue.set(state, 'activeParent', data)
    },

    ACTIVE_DEVICE(state: DevicesState, data: any[] | any | null) {
      Vue.set(state, 'activeDevice', data)
    },

    SELECT_ITEM(state: DevicesState, data: any) {
      Vue.set(state, 'selectedItem', data)
    },

    LOAD_DEVICES(state: DevicesState, data: any[]) {
      Vue.set(state, 'devices', data)
    },
  },

  actions: {
    async resetDevicesState({ commit }: any) {
      commit('RESET_DEV_STATE')
    },

    async updateDevice({ commit, state }: any, payload: { id: string; moduleId: string; name: string; template: any }) {
      const obj$ = await $_bridge.getObjectById(payload.id)
      const object = await obj$.createOrUpdateChild({
        cls: 'module',
        id: payload.moduleId,
        name: payload.name,
        template: payload.template,
      })
    },

    async loadTree({ commit, dispatch }: any) {
      try {
        const logicQuery = {
          id: ['/logical/services'],
          data: {
            namePath: true,
            children: {
              data: {
                children: true,
                namePath: true,
                tags: true,
              },
              filter: { cls: { nin: ['folder'] } },
              tags: true,
            },
          }
        }

        const logicCo = await $_bridge.cmdbQuery(logicQuery)
        const query = {
          id: ['/physical'],
          data: {
            namePath: true,
            children: {
              data: {
                children: true,
                namePath: true,
                tags: true,
              },
              filter: { cls: { nin: ['folder'] } },
              tags: true,
            },
          }
        }

        const co = await $_bridge.cmdbQuery(query)
        
        if(co) {
          commit('SET_ROOT_ELEMENT', co[0])
          
          const cycle = async (arr: TreeItem[]): Promise<TreeItem[]> => {
            arr.forEach((item) => {
              if(item.cls === 'folder') {
                return
              }
              $_bridge.subscribe([item.$id])
              if(item.cls === 'cabinet' || item.cls === 'module' || item.cls === 'service') {
                delete item.children
              }
              if(item.cls === 'device' && item.tree_view === true) {
                delete item.children
              }
              if(item.children?.length) {
                item.children = []
              }
            })
            return arr.sort((a, b) => (b.cls === 'service' ? 1 : 0) - (a.cls === 'service' ? 1 : 0))
          }
          
          let children = await cycle(co[0].children)
          
          if(logicCo?.length && logicCo[0].children) {
            const logicChildren = await cycle(logicCo[0].children)
            if(logicChildren.length) {
              logicChildren.forEach((lc: TreeItem) => {
                children.unshift(lc)
              })
            }
          }

          console.log('STORE', 'loadTree', 'children$', children)
          commit('LOAD_TREE', children)
          commit('CURRENT_ROOT_SHOW', children.length === 0)
        } else {
          alert('smth wrong with server')
          console.log('STORE', 'loadTree', 'smth wrong')
        }
      } catch (err) {
        alert('smth wrong with server ' + err)
        console.error('CATCH', 'STORE', 'LOADTREE', err)
      }
    },

    activeSidebar({ commit }: any, data: string) {
      try {
        commit('ACTIVE_SIDEBAR', data)
      } catch (err) {
        console.error('CATCH', 'STORE', 'ACTIVESIDEBAR', err)
      }
    },

    async setDialog({ commit }: any, data: DialogData) {
      try {
        commit('SET_DIALOG', data)
      } catch (err) {
        console.error('CATCH', 'STORE', 'setDialog', err)
      }
    },

    async closeDialog({ commit }: any, data?: { data: { id: string } }) {
      try {
        if(data?.data) {
          commit('CLOSE_DIALOG', data.data)
        } else {
          commit('CLOSE_DIALOG')
        }
      } catch (err) {
        console.error('CATCH', 'STORE', 'closeDialog', err)
      }
    },

    async activeTree({ commit }: any, data: TreeItem) {
      commit('ACTIVE_TREE', [data])
    },

    async currentActiveTree({ commit }: any, data: TreeItem) {
      commit('CURRENT_ACTIVE_TREE', data)
    },

    async activeTreeObj({ commit, dispatch }: any, id: string) {
      const query = {
        id: [id],
        notNull: true,
        data: {
          namePath: true,
          children: {
            data: {
              children: true,
              namePath: true,
            },
            filter: { cls: { nin: ['folder'] } }
          },
          parent: {
            data: {
              children: {
                data: {
                  children: {
                    data: {
                      children: true,
                      namePath: true,
                    },
                  },
                  namePath: true,
                },
                filter: { cls: { nin: ['folder'] } }
              },
            },
          }
        }
      }
      
      const obj = await $_bridge.cmdbQuery(query)
      if(obj) {
        commit('ACTIVE_TREE', obj)
        if(obj[0].cls === 'cabinet') {
          commit('ACTIVE_CABINET', obj[0])
        }
        if(obj[0].cls === 'device' || obj[0].cls === 'module') {
          dispatch('activeDevice', obj[0])
        }
        return obj[0]
      }
    },

    async activeDevice({ commit, dispatch, state }: any, data: any) {
      if(data?.$id) {
        const obj = data._cmdb_ ? data : new CCMDBObject(data)
        const children = await obj.getLinks({ compute: 'is_used' })
        if(children) {
          obj.children = children
          commit('ACTIVE_DEVICE', obj)
        } else {
          commit('ACTIVE_DEVICE', data)
        }
      } else {
        commit('ACTIVE_DEVICE', data)
      }
    },

    selectItem({ commit }: any, data: any) {
      commit('SELECT_ITEM', data)
    },

    activeCabinet({ commit }: any, data: any) {
      commit('ACTIVE_CABINET', data)
      commit('ACTIVE_DEVICE', null)
    },

    selectLocation({ commit }: any, data: Record<string, any>) {
      commit('SELECTED_LOCATION', data)
    },

    activeParent({ commit }: any, data: Record<string, any>) {
      commit('ACTIVE_PARENT', data)
    },

    async loadChildren({ commit, state, dispatch }: any, data_: any) {
      console.log('loadChildren on DEVICES store started', data_)

      try {

        if(data_?.cls === 'service') {
          console.log('loadChildren data_.cls == service', data_)
          return
        }

        const data = data_._cmdb_ ? data_ : new CCMDBObject(data_)

        let parents
        if(data.parents) {
          parents = data.parents
        } else {
          parents = await data.getParents()
          parents.splice(0, 1)
        }

        const query = {
          id: [data.$id],
          notNull: true,
          data: {
            namePath: true,
            children: {
              data: {
                children: true,
                namePath: true,
              },
              filter: { cls: { nin: ['folder'] } }
            },
          }
        }
        
        const co = await $_bridge.cmdbQuery(query)
        if(co) {
          console.log('STORE', 'loadChildren', 'co$', co)
          
          const cycle = async (arr: TreeItem[]): Promise<TreeItem[]> => {
            arr.forEach((item) => {
              $_bridge.subscribe([item.$id])
              if(item.cls === 'cabinet' || item.cls === 'device' || item.cls === 'module') {
                delete item.children
              }
              if(item.cls === 'location' && item.children) {
                const l = item.children.filter(it => !(it.cls === 'device' && !it.tree_view))
                if(!l.length) delete item.children
              }
              if(item.children?.length) {
                item.children = []
              }
            })
            return arr
          }
          
          $_bridge.subscribe([co[0].$id])

          let children: TreeItem[] = []
          if(co[0].cls === 'cabinet' && co[0].children) {
            delete co[0].children
          } else {
            children = await cycle(co[0].children)
            console.log('STORE', 'loadChildren', 'children$', children)
            co[0].children = children
          }
          
          const updateTree = async (arr: TreeItem[]) => {
            arr.forEach((item, i) => {
              if(item.$id === data.$id) {
                if(children.length) {
                  Vue.set(data, 'children', children)
                }
                Vue.set(arr, i, data)
                commit('UPDATE_TREE', data)
                return
              }
              if(item.children) {
                updateTree(item.children)
              }
            })
          }
          
          // если были открыты далёкие потомки, то их тоже подгружаем
          const allOpened = [[], ...state.onceTreeOpened]
          allOpened.forEach((item: string) => {
            const f = children.find(child => child.$id === item)
            if(f) {
              f.parents = parents
              dispatch('loadChildren', f)
            }
          })

          //в случае, если loadChildren вызван для root-элемента, необходимо отдельно пройтись и удалить из state.tree то, чего нет в обновленном root.children.
          if(co[0].namePath == '/physical') {
            state.tree.forEach((item, index) => {
              if(!co[0].children.some(root => root.$id == item.$id)) {
                if(item.cls != 'folder' && item.cls != 'service') {//нужно удалить только physical объекты
                  state.tree.splice(index, 1)
                }               
              }
            })
          }
          
          await updateTree(state.tree)

        }
      } catch (err) {
        console.error('CATCH', 'STORE', 'LOAD CHILDREN', err)
      }
    },
    
    async loadDevices({ commit }: any, data_: any) {
      try {
        const query = {
          id: [data_.$id],
          notNull: true,
          data: {
            links: {
              flatten: false,
              data: {
                refs: {
                  data: {
                    filter: { cls: ['project'] }
                  },
                  filter: { cls: ['project'] }
                }
              }
            }
          }
        }
        
        const obj = await $_bridge.cmdbQuery(query)
        const children = obj[0].links
        
        if(children) {
          commit('LOAD_DEVICES', children)
        } else {
          console.log('STORE', 'loadDevices', 'getLinks', 'SMTH WRONG', children)
        }
      } catch (err) {
        console.error('CATCH', 'STORE', 'LOAD DEVICES', err)
      }
    },
  },

  getters: {
    getDevices(state: DevicesState): TreeItem[] {
      return state.tree
    },

    getRootElement(state: DevicesState): any {
      return state.rootElement
    },
    
    getActiveCabinet(state: DevicesState): any {
      return state.activeCabinet
    },

    getTreeActive(state: DevicesState): TreeItem | null {
      return state.treeActive.length ? state.treeActive[0] : null
    },

    getCurrentTreeActive(state: DevicesState): TreeItem | null {
      return state.currentTreeActive ? state.currentTreeActive : null
    },

    getActiveDevice(state: DevicesState): any[] | any | null {
      return state.activeDevice
    },

    getSelectedItem(state: DevicesState): any {
      return state.selectedItem
    },

    getDialogs(state: DevicesState): Record<string, DialogState> {
      return state.dialog
    },
  },
}